
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import DatePicker from 'v-calendar/lib/v-calendar.umd'

const dateFormat = 'DD-MMM-YYYY'

@Component({ components: DatePicker })
export default class DateRangeInput extends Vue {
    @Prop({ type: Date, default: new Date() }) public from!: Date
    @Prop({ type: Date, default: new Date() }) public to!: Date
    @Prop(Function) public onChange!: ({ from, to }) => void
    @Prop({ type: Boolean, default: false }) public startOpen?: boolean

    private startDatePickerOpen = false

    public range = {
        start: this.from,
        end: this.to,
    }

    public masks = {
        input: dateFormat,
    }

    private mounted() {
        this.startDatePickerOpen = this.startOpen || false
    }

    public applyChange() {
        if (this.range.start === this.from && this.range.end === this.to) {
            return
        }

        this.onChange({
            from: this.range.start,
            to: this.range.end,
        })
    }

    public showDatePickerOnOpen(showPopover: Function) {
        if (this.startDatePickerOpen) {
            showPopover()
            this.startDatePickerOpen = false
        }
    }
}
